import React, { useContext, useState } from "react";
import {
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ExpandMore } from "@material-ui/icons";
import _ from "lodash";

import {
  EditableTable,
  DeliverForm,
  SubmitDialog,
  DistanceAlert,
} from "../components";
import { OrderContext } from "../context";
import {
  getTotalPriceStr,
  isDev,
  isDeveloperDev,
  getDeliverCost,
  getPartnerName,
} from "../helpers";
import { useDistance } from "../services/googleMap";
import PrettyJSON from "../components/PrettyJSON";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
    marginRight: 20,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default (props) => {
  const classes = useStyles();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { orders } = useContext(OrderContext);
  const [orderID, setOrderID] = useState(null);
  const [expanded, setExpanded] = useState("deliverForm");
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const [address, setAddress] = useState({
    partnerAddress: "",
    customerAddress: "",
  });

  const handleAddress = (newAddress) => {
    if (!_.isEqual(newAddress, address)) {
      console.log(newAddress, address);
      setAddress(newAddress);
    }
  };
  const distanceState = useDistance(address);
  const deliverCost = getDeliverCost(
    distanceState.distance,
    props.deliverCondition?.freeDistance
  );

  return (
    <>
      {Boolean(distanceState.status) && (
        <DistanceAlert
          distanceState={distanceState}
          deliverCost={deliverCost}
        />
      )}
      <SubmitDialog
        isSubmitted={[isSubmitted, setIsSubmitted]}
        orderID={orderID}
      />
      <div className={classes.root}>
        {isDev && (
          <PrettyJSON json={{ address, distanceState }} keyLabel="checkout" />
        )}
        {[
          {
            id: "orderList",
            title: "Bestellungen",
            subTitle: `Total: ${getTotalPriceStr(orders)} Euro`,
            content: <EditableTable />,
          },
          {
            id: "deliverForm",
            title: "Kontakt Information",
            subTitle: "",
            content: (
              <>
                <DeliverForm
                  // minDeliverTotal={props.minDeliverTotal}
                  // noDeliverExplaination={props.noDeliverExplaination}
                  deliverCondition={props.deliverCondition}
                  isSubmitted={[isSubmitted, setIsSubmitted]}
                  setOrderID={setOrderID}
                  handleAddress={handleAddress}
                  deliverCost={deliverCost.cost}
                  partnerLocations={props.partnerLocations}
                />
              </>
            ),
          },
        ].map(({ id, title, subTitle, content }) => (
          <ExpansionPanel
            key={id}
            expanded={expanded === id}
            onChange={handleChange(id)}
          >
            <ExpansionPanelSummary
              expandIcon={<ExpandMore />}
              aria-controls={id + "-content"}
              id={id + "-head"}
            >
              <Typography className={classes.heading}>{title}</Typography>
              <Typography className={classes.secondaryHeading}>
                {subTitle}
              </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>{content}</ExpansionPanelDetails>
          </ExpansionPanel>
        ))}
      </div>
    </>
  );
};
